import {Type} from '@angular/core';
import {DynamicFieldComponent} from '../dynamic-field/dynamic-field-component';
import {FieldTypeEnum} from '../dynamic-field/field-type.enum';
import {NumberFieldComponent} from './number/number-field/number-field.component';
import {TextFieldComponent} from './text/text-field/text-field.component';
import {TextAreaFieldComponent} from './textarea/text-area-field/text-area-field.component';
import {SelectFieldComponent} from './select/select-field/select-field.component';
import {CheckboxFieldComponent} from './checkbox/checkbox-field/checkbox-field.component';
import {DateFieldComponent} from './date/date-field/date-field.component';
import {DatetimeFieldComponent} from './datetime/datetime-field/datetime-field.component';
import {IconFieldComponent} from './icon/icon-field/icon-field.component';
import {ImageFieldComponent} from './image/image-field/image-field.component';
import {TimeFieldComponent} from './time/time-field/time-field.component';
import {OptionFieldComponent} from './options/option-field/option-field.component';
import {ButtonFieldComponent} from './button/button-field/button-field.component';
import {SlideToggleFieldComponent} from './slidetoggle/slide-toggle-field/slide-toggle-field.component';
import {LabelFieldComponent} from './label/label-field/label-field.component';
import {FilterSelectFieldComponent} from './filter-select/select-field/filter-select-field.component';
import {FileSelectFieldComponent} from './file-select/file-select-field/file-select-field.component';
import {ChipsFieldComponent} from './chips/chips-field/chips-field.component';
import {ChipsMultiSelectFieldComponent} from './chips-multiselect/chips-multiselect-field/chips-multiselect-field.component';
import {MultiOptionComponent} from './multi-option/multi-option-field/multi-option.component';
import {CustomFieldComponent} from './custom/custom-field/custom-field.component';
import {DividerFieldComponent} from './divider/divider-field/divider-field.component';
import {ButtonToggleComponent} from './button-toggle/button-toggle-field/button-toggle.component';
import {SignatureFieldComponent} from './signature/signature-field/signature-field.component';


export const FieldTypeToComponent = new Map<FieldTypeEnum, Type<DynamicFieldComponent>>([
    [FieldTypeEnum.button, ButtonFieldComponent],
    [FieldTypeEnum.checkbox, CheckboxFieldComponent],
    [FieldTypeEnum.date, DateFieldComponent],
    [FieldTypeEnum.datetime, DatetimeFieldComponent],
    [FieldTypeEnum.icon, IconFieldComponent],
    [FieldTypeEnum.image, ImageFieldComponent],
    [FieldTypeEnum.number, NumberFieldComponent],
    [FieldTypeEnum.select, SelectFieldComponent],
    [FieldTypeEnum.text, TextFieldComponent],
    [FieldTypeEnum.textarea, TextAreaFieldComponent],
    [FieldTypeEnum.time, TimeFieldComponent],
    [FieldTypeEnum.option, OptionFieldComponent],
    [FieldTypeEnum.slidetoggle, SlideToggleFieldComponent],
    [FieldTypeEnum.label, LabelFieldComponent],
    [FieldTypeEnum.filterSelect, FilterSelectFieldComponent],
    [FieldTypeEnum.fileSelect, FileSelectFieldComponent],
    [FieldTypeEnum.chips, ChipsFieldComponent],
    [FieldTypeEnum.chipsMultiSelect, ChipsMultiSelectFieldComponent],
    [FieldTypeEnum.multiOption, MultiOptionComponent],
    [FieldTypeEnum.custom, CustomFieldComponent],
    [FieldTypeEnum.buttonToggle, ButtonToggleComponent],
    [FieldTypeEnum.divider, DividerFieldComponent],
    [FieldTypeEnum.signature, SignatureFieldComponent]
]);

